import { Avatar, Form, Modal, Row, Col, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import HttpStatus from '../../../utility/status.enum';
import chagePasswordIcon from '../../../static/img/chagePassword.svg';
import rightIcon from '../../../static/img/icon/chevron-right.svg';
import pmsIcon from '../../../static/img/pms-icon.svg';
import profileicon from '../../../static/img/avatar/profile-icon.svg';
import Changepassword from '../../../container/pages/changePassword/ChangePassword';
import UpdateProfile from '../../../container/profile/updateProfile/UpdateProfile';
import { logOut, switchAccount, switchBack } from '../../../redux/authentication/actionCreator';

import { getProfile } from '../../../redux/userProfile/actionCreator';
import signouticon from '../../../static/img/sign-out-icon.svg';
import Notification from '../../../utility/notification.js';
import stripeIcon from '../../../static/img/stripe.svg';
import paypalConnectIcon from '../../../static/img/paypal-connect.svg';
import { stripeInvitation } from '../../../redux/manageStripe/actionCreator';
import { paypalInvitation } from '../../../redux/managePaypal/actionCreator';
import Spinner from '../../../../src/container/common/Spinner';
import UserAvatar from '../../../static/img/user-avtar.webp';
import settingIcon from '../../../static/img/export-message-icon.svg';
import cardOnFileIcon from '../../../static/img/card-on-file.svg';

import { AddUser } from '../../../container/pages/style.js';
import { BasicFormWrapper } from '../../../container/styled.js';
import { Button } from '../../../components/buttons/buttons';
import { hostListing, getMembersAccountData } from '../../../redux/manageHost/actionCreator';
import { useParams } from 'react-router-dom';

const AuthInfo = React.memo(() => {
  const mainPathSplit = window.location.pathname.split('/');
  const hostSlug = mainPathSplit?.length === 3 && mainPathSplit[1] === 'settings' ? mainPathSplit[2] : '';
  const { unsaveMessage, backEndPrefix, hostLoginRoleID, providerLoginRoleID, adminLoginRoleID} = global;
  const dispatch = useDispatch();
  const [loginUser, setLoginUser] = useState([]);
  const isMounted = useRef(true);
  const navigate = useNavigate();
  const [spinnerLoader, setSpinnerLoader] = useState(false);
  const [isSettingsEnabled, setIsSettingsEnabled] = useState(2);  // usestate for settings
  const providerHostNotStripeLink = ([hostLoginRoleID, providerLoginRoleID].includes(loginUser.role_id) && loginUser.is_stripe_status !== 2);
  const providerHostNotPaypalLink = ([hostLoginRoleID, providerLoginRoleID].includes(loginUser.role_id) && loginUser.paypal_onboarding_status !== 2);
  // const paymentMethodsShow = (global.checkPermission('payment-method-index') && global.isShowCardsOnFile);
  const paymentMethodsShow = false;
  const [addClassPaymentMethodDynamic, setAddClassPaymentMethodDynamic] = useState('');

  const [hostSelectPopup, setHostSelectPopup] = useState(false);
  const [filterForm] = Form.useForm(); 
  const [hostDropdownList, setHostDropdownList] = useState([]);
  const [userProfileOptionClass, setUserProfileOptionClass] = useState('');
  const [profileImage, setProfileImage] = useState(null);
  const [membersAccount, setMembersAccount] = useState([]); // State to store the list of member accounts (initialized as empty array)
  const [ownerAccount, setOwnerAccount] = useState(); // State to store the owner account details (initially undefined)
  const [switchProfilePopup, setProfilePopup] = useState(false); // State to control visibility of the switch profile popup (default: hidden)
  const isSwitchProfile = global.checkPermission("settings-switch-profile")
  const hasAccountData = !!ownerAccount || membersAccount.length > 0; // Check if there is any account data available

  useEffect(() => {
    filterForm.setFieldsValue({
      host_slug: hostSlug || null
    })
  }, [hostSlug]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const getProfileFunction = async () => {
        try {
          const profileResponse = await dispatch(getProfile());
          if (profileResponse?.status !== HttpStatus.HTTP_OK) {
            // Show Error Alert
          } else {
            global.isChatStatus= profileResponse?.result?.is_chat_enable === 1 || profileResponse?.result?.role_id === global.adminLoginRoleID;   // chat enable or disable status
            setLoginUser(profileResponse?.result)
            setProfileImage(profileResponse?.result?.image)
            global.paymentHostOption = profileResponse?.result?.payment_type;
            global.importFromListingFlag = profileResponse?.result?.is_import_from_pms_enable;
            global.isShowCardsOnFile = profileResponse?.result?.is_allowed_card_file || false;
            global.hostCreatedDate = profileResponse?.result?.host_created_date || null;
            global.stripeStatus = profileResponse?.result?.is_stripe_status || null;
            global.paypalOnboardingStatus = profileResponse?.result?.paypal_onboarding_status || null;
            global.cardStatus = profileResponse?.result?.is_card_added || null;            
            global.stripeUrl = profileResponse?.result?.stripe_invitation_link || null;  
            global.isAllowClaim = profileResponse?.result?.is_allow_claim || false;
            global.isStripeStatus = profileResponse?.result?.is_stripe_connect_for_host_claim || 0;
            global.isTernStripeStatus = profileResponse?.result?.is_tern_stripe_host_connect || 0;
            global.isAiChatEnabled = profileResponse?.result?.is_ai_chat_enable == 1;
            /*
            let isMessageTabShow = profileResponse?.result?.role_id === adminLoginRoleID; // IsAdmin
            // isHost
            if(profileResponse?.result?.role_id === hostLoginRoleID) {
              isMessageTabShow = profileResponse?.result?.is_scheduler_enable === 1;
            }
            global.isSchedularEnableHost = isMessageTabShow
            */          
          }
        } catch (error) {
        }
      };
      getProfileFunction();
    }
  }, []);

  const [changepasswordModal, setChangepasswordModal] = useState(false);
  const [isChangePasswordDirty, setChangePasswordDirty] = useState(false);
  const handlechangepasswordModal = () => {
    setChangepasswordModal(true);
  };

  const handleChangePasswordInputChange = () => {
    setChangePasswordDirty(true);
  };

  const hidechangepasswordModal = () => {
    if (isChangePasswordDirty) {
      const confirmCancel = window.confirm(unsaveMessage);
      if (confirmCancel) {
        setChangePasswordDirty(false);
        setChangepasswordModal(false);
      }
    } else {
      setChangepasswordModal(false);
    }
  };

  const [updateProfileModal, setUpdateProfileModal] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const handlecupdateProfileModal = () => {
    setUpdateProfileModal(true);
  };
  const handleProfileInputChange = () => {
    setIsDirty(true);
  };
  const handleImageClearChange = () => {
    setIsDirty(false);
  };
  
  const hideUpdateProfileModal = () => {
    if (isDirty) {
      const confirmCancel = window.confirm(unsaveMessage);
      if (confirmCancel) {
        setIsDirty(false);
        setUpdateProfileModal(false);
      }
    } else {
      setUpdateProfileModal(false);
    }
  };

  const [state, setState] = useState({
    flag: 'en',
  });

  const SignOut = (e) => {
    e.preventDefault();
    const logoutFunction = async () => {
      try {
        const logoutResponse = await dispatch(
          logOut(),
        );
        if (logoutResponse?.status !== HttpStatus.HTTP_OK) {
          Notification.addNotificationError(logoutResponse.message);
        } else {
          Notification.addNotificationSuccess(logoutResponse.message);
          navigate('/')
        }
      } catch (error) {
      }
    }
    logoutFunction();

  };

   // Send Stripe Invitaion Email:
   const handleConnectStripeEvent = () => {
    if (loginUser.slug) {
      setSpinnerLoader(true);
      const slug = loginUser.slug;
      const is_send_email = 2; // Email will not send
      const requestData = { slug,is_send_email};
      const stripeInvitationLinkGetFunction = async () => {
        try {
          const stripeInvitationResponse = await dispatch(
            stripeInvitation(requestData, (response) => {
              return response;
            }),
          );
          if (stripeInvitationResponse?.status === HttpStatus.HTTP_OK) {           
           const stripeLink = stripeInvitationResponse?.result?.stripe_invitation_link;
           window.open(stripeLink, '_blank');
          } else {
            Notification.addNotificationError(stripeInvitationResponse.message);
          }
          setSpinnerLoader(false);
        } catch (error) {
          // console.error('Error fetching data:', error);
        }
      };
      stripeInvitationLinkGetFunction();
    }
  }

   // Open PayPal onboarding link (no email):
   const handleConnectPaypalEvent = () => {
    if (loginUser.slug) {
      setSpinnerLoader(true);
      const slug = loginUser.slug;
      const is_send_email = 2; // Email will not send
      const requestData = { slug, is_send_email };
      const paypalInvitationLinkGetFunction = async () => {
        try {
          const paypalInvitationResponse = await dispatch(
            paypalInvitation(requestData, (response) => {
              return response;
            }),
          );
          if (paypalInvitationResponse?.status === HttpStatus.HTTP_OK) {
           const paypalLink = paypalInvitationResponse?.result?.action_url;
           window.open(paypalLink, '_blank');
          } else {
            Notification.addNotificationError(paypalInvitationResponse.message);
          }
          setSpinnerLoader(false);
        } catch (error) {
          // console.error('Error fetching data:', error);
        }
      };
      paypalInvitationLinkGetFunction();
    }
  }

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">        
        <div style={{ width: "180px" }}>

        </div>
      </div>
    </UserDropDwon>
  );
  
  const [addClassDynamic, setAddClassDynamic] = useState('');

  useEffect(() => {
    const isHost = loginUser.role_id === hostLoginRoleID
    const isProvider = loginUser.role_id === providerLoginRoleID;
    const isAdmin = loginUser.role_id === adminLoginRoleID;
    const isStripeConnected = loginUser.is_stripe_status === 2;
    let className = '';
    if(isAdmin){
      className = 'payout-menu';
    } else if (isHost) {
      // Host logic
      if (isStripeConnected && !isSwitchProfile) {
        className = 'pms-user_profile_box';
      } else if (!paymentMethodsShow) {
        // Keep empty if not connected and no payment methods shown
        className = '';
      } else {
        className = 'payout-setting-profile-box';
      }
    } else if (isProvider && !isStripeConnected) {
      // Provider not connected to Stripe
      className = 'payout-menu';
    }
    if(isHost && paymentMethodsShow){
      className = '';
    }
    setAddClassDynamic(className);
    // Check if user is a host and has permission to switch profiles
    if(isHost && isSwitchProfile){
      // Fetch the child account details associated with the host
      fetchChildAccount();
    }
  }, [loginUser])

  const handleMenuClick = (e, path) => {
    e.preventDefault();

    const navigateToPath = () => {
      if (path === "settings") {
        setHostSelectPopup(true);
        fetchHostData();
      } else {
        navigate(`/${path}`);
      }
    };

    // If there are unsaved changes
    if (global.isDirtyGlobal) {
      const confirmCancel = window.confirm(unsaveMessage);
      if (!confirmCancel) return; // User canceled
      // User confirmed navigation
      global.isDirtyGlobal = false;
      navigateToPath();
    } else {
      // No unsaved changes — navigate directly
      navigateToPath();
    }
  };
  
  const fetchChildAccount = async () => { // Async function to fetch child/member account data
    setSpinnerLoader(true); // Show loading spinner before API call starts
    try {
      // Get and parse default user from localStorage
      const defaultUser = JSON.parse(localStorage.getItem('default_user') || 'null');
      // Use default user if exists, otherwise logged-in user
      const ownerForFetch = defaultUser || loginUser;
      // Call Redux thunk to fetch member accounts
      const membersAccountResponse = await dispatch(
        getMembersAccountData(ownerForFetch?.slug)
      );
      if (membersAccountResponse?.status === HttpStatus.HTTP_OK) { // Check if API response is successful
        const members = membersAccountResponse?.result || []; // Get members list
        // store "default owner" for display (can be null)
        setOwnerAccount(defaultUser); // Set default user as owner
        // Remove logged-in user from members list
        const filteredMembers = members.filter(
          member => member?.slug !== loginUser?.slug
        );
        setMembersAccount(filteredMembers); // Set filtered members to state
      }
    } catch (error) {}
    finally {
      setSpinnerLoader(false); // Hide loading spinner after API call completes (success or failure)
    }
  };

  const handleOpenProfilePopup = () => { // Set state to show the profile popup
    setProfilePopup(true);
  };

  const handleSwitchAccount = async (slug) => {
    setSpinnerLoader(true);
    try {
      const switchAccountResponse = await dispatch(switchAccount({ target_account_slug: slug })); // Dispatch Redux action to switch account using that slug
      // Check if the response status is HTTP_FORBIDDEN (403)
      // This means the user is not allowed to switch to that account
      if(switchAccountResponse?.status === HttpStatus.HTTP_FORBIDDEN){
        Notification.addNotificationError(switchAccountResponse?.message);
      }
    } catch (error) {}
    finally {
      setSpinnerLoader(false);
    }
  };

  // Function to dispatch switchBack action
  const handleSwitchBack = async () => {
    setSpinnerLoader(true);
    try {
      const switchBackResponse = await dispatch(switchBack());
      // Check if the response status is HTTP_BAD_REQUEST (400)
      // This means the request was invalid or something failed on the server
      if(switchBackResponse?.status === HttpStatus.HTTP_BAD_REQUEST){
        Notification.addNotificationError(switchBackResponse?.message);
      }
    } catch (error) {}
    finally {
      setSpinnerLoader(false);
    }
  };

  const handleCancelHostSelectPopup = () => {
    setHostSelectPopup(false);
    setProfilePopup(false); // Close/hide the profile switch popup
  };

  const onSubmitSearch = (values) => {
    if (!values.host_slug) {
      Notification.addNotificationError('Please select host');
      return;
    }
    setHostSelectPopup(false); // Close the host select popup
    navigate(`settings/${values.host_slug}`);
  };

  // For admin use only: Select the host to edit the listing
  const fetchHostData = async () => {
    setSpinnerLoader(true);
    try {
      const hostResponse = await dispatch(
        hostListing({
          is_filter: 1, // fetch without pagination host list
        }),
      );
      if (hostResponse.status === HttpStatus.HTTP_OK) {
        setHostDropdownList(hostResponse.result);
      }
    } catch (error) {}
    finally {
      setSpinnerLoader(false);
    }
  };



  useEffect(() => {
  if (!loginUser) return;

  const isAdmin = loginUser.role_id === adminLoginRoleID;
  const isHost = loginUser.role_id === hostLoginRoleID;
  const isProvider = loginUser.role_id === providerLoginRoleID;
  const isProviderOrAdmin =
    (providerHostNotStripeLink && (paymentMethodsShow || isProvider)) || isAdmin;
  const isStripeConnected = loginUser.is_stripe_status === 2;
  let classes = ['user_profile_option'];

  // All 5 options showing at once: Payout Settings, Paypal Connect, Settings, Switch Profile, Sign Out
  if (providerHostNotStripeLink && providerHostNotPaypalLink && global.checkPermission("settings-switch-profile") && hasAccountData) {
    classes.push('has-all-payout-options');
  }

  // Case 1: Add new menu item class for providers/admins without Stripe link
  if (isProviderOrAdmin) {
    classes.push('new_menu_item_add');
  }

  // Case 2: Host-specific classes
  if (isHost) {
    classes.push('new_menu_added_setting', 'two-menu-items');
    if(global.checkPermission("settings-switch-profile") && !isStripeConnected && hasAccountData){
      classes.push('new_menu_item_add')
    }

    // Desktop: If no cards on file & not linked to Stripe
    if (!paymentMethodsShow && !providerHostNotStripeLink && !isSwitchProfile) {
      classes.push('two-menu-items-no-cards-desktop'); 
    }

    // Desktop: Apply class when no payments, no Stripe, can switch, no data
    if (!paymentMethodsShow && !providerHostNotStripeLink && isSwitchProfile && !hasAccountData) {
      classes.push('two-menu-items-no-cards-desktop'); 
    }
  }

  setUserProfileOptionClass(classes.join(' '));
}, [loginUser, hasAccountData]);

useEffect(() => {
  if(global.updatedLoginProfile && loginUser?.role_id === hostLoginRoleID){
    setProfileImage(global.updatedLoginProfile);
  }
}, [global.updatedLoginProfile, loginUser]);

  return (
    <InfoWraper className="autoprofile">
      <Spinner loader={spinnerLoader} />
      <div className="d-flex justify-content-center w-100 flex-column">
        <div
          className={`ninjadash-nav-actions__item ninjadash-nav-actions__author d-flex align-items-center user_profile_box ${addClassDynamic}`}
        >
          <Link to="#" className="ninjadash-nav-action-link d-flex">
            {loginUser && profileImage ? <Avatar src={profileImage} /> : <Avatar src={UserAvatar} />}
            <div className="ml-10 admin_welcome_box">
              <span className="welcome d-block">Welcome</span>
              <span className="ninjadash-nav-actions__author--name">{loginUser ? loginUser.name : ''}</span>
            </div>
          </Link>
          <div className={userProfileOptionClass}>
            {providerHostNotStripeLink && (
              <Link onClick={handleConnectStripeEvent} className="settings">
                <img src={stripeIcon} />
                {/* <span>Payout Settings</span> */}
                <span>Stripe Settings</span>
              </Link>
            )}
            {providerHostNotPaypalLink && (
              <Link onClick={handleConnectPaypalEvent} className="settings">
                <img src={paypalConnectIcon} />
                <span>PayPal Settings</span>
              </Link>
            )}
            {([hostLoginRoleID].includes(loginUser.role_id)) && global.checkPermission("settings-index") && (
              <Link to={`/settings`} className='settings'>
                <img src={pmsIcon} />
                <span>Settings</span>
              </Link>
            )}
            {([hostLoginRoleID].includes(loginUser.role_id)) && global.checkPermission("settings-switch-profile") && hasAccountData && ( // Check role and permission to access settings
              // Render link and trigger fetchChildAccount when clicked              
              <Link className='settings' onClick={handleOpenProfilePopup}> 
                <img src={profileicon} />
                <span>Switch Profile</span>
              </Link>
            )}
            {([adminLoginRoleID].includes(loginUser.role_id)) && global.checkPermission("settings-index") && (
              <Link to="#" className='settings'  onClick={(e) => handleMenuClick(e, 'settings')}>
                <img src={pmsIcon} />
                <span>Settings</span>
              </Link>
            )}
            {/*{global.checkPermission('settings-index') && (
              <Link to="#" className="settings" onClick={(e) => handleMenuClick(e, 'crm-export-settings')}>
                <img src={settingIcon} />
                <span>CRM Exports</span>
              </Link>
            )}
            {global.checkPermission('pms-integration-index') && (
              <Link className="pms-intergation-desktop settings" onClick={(e) => handleMenuClick(e, 'pms-integration')}>
                <img src={pmsIcon} />
                <span>PMS Integration</span>
              </Link>
            )} */}
            {([adminLoginRoleID, providerLoginRoleID].includes(loginUser.role_id)) && (
              <>
                <Link to="#" className='settings' onClick={handlecupdateProfileModal}>
                  <img src={profileicon} />
                  <span>Update Profile</span>
                </Link>
                <Link to="#" className='settings' onClick={handlechangepasswordModal}>
                  <img src={chagePasswordIcon} />
                  <span>Change Password</span>
                </Link>
              </>
            )}
            {/* {paymentMethodsShow && (
              <Link className="pms-intergation-desktop settings" onClick={(e) => handleMenuClick(e, 'cards-on-file')}>
                <img src={cardOnFileIcon} />
                <span>Cards On File</span>
              </Link>
            )} */}
            <Link type="button" onClick={SignOut} className="settings">
              <img src={signouticon} />
              Sign Out
            </Link>
          </div>
        </div>
      </div>
      <UpdateProfile
        updateProfileModal={updateProfileModal}
        hideUpdateProfileModal={hideUpdateProfileModal}
        handleProfileInputChange={handleProfileInputChange}
        handleImageClearChange={handleImageClearChange}
      />
      <Changepassword
        changepasswordModal={changepasswordModal}
        hidechangepasswordModal={hidechangepasswordModal}
        handleChangePasswordInputChange={handleChangePasswordInputChange}
      />

      {/* Modal for select host; for admin only */}
      {hostSelectPopup && hostDropdownList.length > 0 && (
      <Modal
        type="primary"
        open={hostSelectPopup}
        title="Search Filter"
        footer={null}
        onCancel={() => handleCancelHostSelectPopup()}
        className="modal-md"
        key={1}
        maskClosable={false}
        aria-hidden="false"
      >
        <div className="project-modal">
          <AddUser>
            <BasicFormWrapper>
              <Form form={filterForm} name="contact" onFinish={onSubmitSearch}>
                <Row gutter={15}>
                  <Col xs={24} md={24}>
                    <div className="project-modal">
                      <Form.Item label="Select Host" name="host_slug" className="custom_input_style">
                        <Select
                          size="large"
                          className="ninjadash-fullwidth-select"
                          placeholder="Select Host"
                          showSearch
                          filterOption={(input, option) => {
                            const children = option.props.children;
                            if (typeof children === 'string') {
                              return children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            } else if (Array.isArray(children)) {
                              const concatenatedString = children.join('');
                              return concatenatedString.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                            }
                            return false;
                          }}
                          allowClear
                        >
                          {hostDropdownList.map((value, index) => (
                            <option key={index} value={value.slug}>
                              {value.name}
                            </option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
                <Row gutter={15} className="mt-20">
                  <Col xs={24}>
                    <Button htmlType="submit" size="default" type="dark" shape="circle" key="submit" className="w-100">
                      Proceed
                    </Button>
                  </Col>
                </Row>
              </Form>
            </BasicFormWrapper>
          </AddUser>
        </div>
      </Modal>
      )}
      {/* Modal for switch profile; for host only */}
      {switchProfilePopup && (
        <Modal
          type="primary"
          open={switchProfilePopup}
          title="Switch Account"
          footer={null}
          onCancel={handleCancelHostSelectPopup}
          className="modal-md"
          maskClosable={false}
        >
          <AddUser>
            <BasicFormWrapper>
              <div className="account-switch-wrapper">
                <div className="current-account-sticky">
              <Row gutter={[15, 15]}>
                {/* ACTIVE USER (always current) */}
                <Col xs={24}>
                  <Row className="account-row">
                    <Col className="account-info">
                      <Avatar
                        className="account-avatar"
                        src={loginUser?.image || UserAvatar}
                        alt={loginUser?.name}
                      />
                      <div className="account-text">
                        <div className="account-name">{loginUser?.name}</div>
                        <div className="account-email">{loginUser?.email}</div>
                      </div>
                    </Col>
                  </Row>
                </Col>
                </Row>
                </div>
                {/* DEFAULT USER (only when impersonating) */}
                <div className="accounts-scroll-area">
                <Row gutter={[15, 15]}>
                {ownerAccount && (
                  <Col xs={24}>
                    <Row className="account-row row-cursor">
                      <Col className="account-info">
                        <Avatar
                          className="account-avatar"
                          src={ownerAccount?.image || UserAvatar}
                          alt={ownerAccount?.name}
                        />
                        <div className="account-text">
                          <div className="account-name">{ownerAccount?.name}</div>
                          <div className="account-email">{ownerAccount?.email}</div>
                        </div>
                      </Col>
                      <Col className='account-switch'>
                        <Link type="button" onClick={() => handleSwitchBack()}>
                          {/* Switch Back */}
                          <img src={rightIcon} className='switch-icon'/>
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                )}
                {/* SWITCHABLE USERS (exclude active already) */}
                {membersAccount.map((account, index) => (
                  <Col xs={24} key={account?.slug || index}>
                    <Row className="account-row row-cursor">
                      <Col className="account-info">
                        <Avatar
                          className="account-avatar"
                          src={account?.image || UserAvatar}
                          alt={account?.name}
                        />
                        <div className="account-text">
                          <div className="account-name">{account?.name}</div>
                          <div className="account-email">{account?.email}</div>
                        </div>
                      </Col>
                      <Col className='account-switch'>
                        <Link type="button" onClick={() => handleSwitchAccount(account.slug)}>
                          {/* Switch Back */}
                          <img src={rightIcon} className='switch-icon'/>
                        </Link>
                      </Col>
                    </Row>
                  </Col>
                ))}
                </Row>
                </div>
              </div>
            </BasicFormWrapper>
          </AddUser>
        </Modal>
      )}
    </InfoWraper>
  );
});

export default AuthInfo;